import React from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { amendHeaders, updateQaEmailPair } from "../../../API/api";
import "./updateEmailStyles.css";
import { DOWNLOAD_HEADERS } from "../../../API/url";
import { toast } from "react-toastify";
import { Input } from "antd";
import TextField from "@mui/material/TextField";

import { handleChangeFrequency } from "../../../Action/actions";
import VizButton from "../../VizButtons/VizButton";



const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};
const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",
  display: "flex",
  //justifyContent: "center",
  width: "100%"


};
export function UpdateEmailQaPair() {
  const dispatch = useDispatch();
  const { getUpdatedSpinner, advanceFilterModalToggle } = bindActionCreators(
    Actions,
    dispatch
  );
  const handleChangeQuestion = () => { };
  const modalState = useSelector((state) => state.domain);
  const drawerState = useSelector((state) => state.drawer);
  const [questions, setQuestion] = React.useState(drawerState?.question);
  const [answers, setAnswer] = React.useState(drawerState?.answer);
  const [isLoading, setLoading] = React.useState(false)
  const followUpToast = (message) => {
    return (
      <>
        <p style={{ fontSize: "12px" }}>{message}</p>
      </>
    );
  };

  const onClickSubmit = () => {
    setLoading(true)
    let payload = {
      "action": "update",
      "qaPairs": [{
        "id": drawerState?.emailId,
        "question": questions,
        "answer": answers
      }]
    }
    updateQaEmailPair(payload).then((res) => {
      setLoading(false)
      advanceFilterModalToggle({ bool: false, value: "" });
      if (res?.data?.success) {
        getUpdatedSpinner(true)
      }

    });

  };

  const buttonLogic = () => {
    if (questions.length > 5 || answers.length > 5) {
      return "Primary"
    } else {
      return "Disabled"
    }
  }
  // console.log(questions.length,answers.length)
  // console.log("button logic",questions.length>5 && answers.length>5 ? "Primary":"Disabled")
  return (
    <>
      {/* <Modal
  show={modalState.modalState}
  size="lg"
  centered={true}
  onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
  dialogClassName="modal-90w"
>
  <Modal.Header closeButton closeVariant="white" className="modalHeaders">
    <Modal.Title style={{ fontSize: "17px" }}>Update</Modal.Title>
  </Modal.Header>
  <Modal.Body 
    style={{ 
      height: '400px', 
      maxHeight: 'calc(90vh - 140px)', // Adjust this value based on your needs
      overflowY: 'auto',
      paddingBottom: "0px",
      paddingRight: "15px" // Add padding to account for scrollbar
    }}
  >
    <div style={{ padding: "5px" }}>
      <label>Question:</label>
      <TextField
        fullWidth
        value={questions}
        onChange={(e) => setQuestion(e.target.value)}
        margin="normal"
        multiline
        minRows={2}
        InputProps={{
          style: {
            height: "auto",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflowWrap: "break-word"
          },
        }}
      />
      <div>
        <label>Answer:</label>
        <TextField
          fullWidth
          value={answers}
          onChange={(e) => setAnswer(e.target.value)}
          margin="normal"
          multiline
          minRows={4}
          InputProps={{
            style: {
              height: "auto",
              width: "100%",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              overflowWrap: "break-word"
            },
          }}
        />
      </div>
    </div>
  </Modal.Body>
  <Modal.Footer style={{ 
    borderTop: '1px solid #dee2e6',
    padding: '1rem',
    backgroundColor: 'white',
    position: 'sticky',
    bottom: 0
  }}>
    <div style={{ 
      display: "flex", 
      justifyContent: "flex-end",
      width: "100%"
    }}>
      <span style={{ paddingRight: "10px" }}>
        <VizButton
          size={2}
          type="Tertiary"
          onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}
        >
          cancel
        </VizButton>
      </span>
      <span>
        <VizButton
          size={2}
          type={questions.length > 0 && answers.length > 0 ? "Primary" : "Disabled"}
          onClick={() => onClickSubmit()}
        >
          Submit
        </VizButton>
      </span>
    </div>
  </Modal.Footer>
</Modal> */}
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        centered={true}
        size={"lg"}
        // style={{ marginTop: "-50px" }}
        style={{ marginTop: "-50px" }}
      // size="lg"
      >

        <Modal.Header closeButton>
          <Modal.Title style={modalTitleStyle}>
            <span>
              <i className="fa fa-book" >&nbsp;&nbsp;</i>Update
              {/* <i class="fa fa-book" aria-hidden="true"> </i> &nbsp;&nbsp; {ingestedState.title} */}
            </span>


          </Modal.Title>
        </Modal.Header>
        <ModalBody>
          <div className="container">
            <p style={{
              fontSize: "16px",
              color: "#2A364A",
            }}>
              Are you sure that you want to unpublish all of these documents?
            </p>

            <div style={{ padding: "5px" }}>
              <label style={textStyles1}>Question:</label>
              {/* <TextField
                  fullWidth
                  value={questions}
                  onChange={(e) => setQuestion(e.target.value)}
                  margin="normal"
                  multiline
                  minRows={2}
                  InputProps={{
                    style: {
                      height: "auto",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      overflowWrap: "break-word"
                    },
                  }}
                /> */}
              <textarea wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none' }} rows={1} type={"text"}
                value={questions}
                onChange={(e) => setQuestion(e.target.value)}
                minRows={2} />
              <div>
                <label style={textStyles1}>Answer:</label>
                {/* <TextField
                    fullWidth
                    value={answers}
                    onChange={(e) => setAnswer(e.target.value)}
                    margin="normal"
                    multiline
                    minRows={4}
                    InputProps={{
                      style: {
                        height: "auto",
                        width: "100%",
                        whiteSpace: "pre-wrap",
                        wordWrap: "break-word",
                        overflowWrap: "break-word"
                      },
                    }}
                  /> */}
                <textarea wrap="soft"
                  style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none' }}
                  rows={3} type={"text"}
                  value={answers}
                  onChange={(e) => setAnswer(e.target.value)}
                  minRows={3} />
              </div>
            </div>

            {!isLoading && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: ' 0px 1px 2px 0px #1018280D',
                    color: '#2A364A',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: " #F6F7F8",
                    marginBottom: '14px',
                    fontWeight: 400,
                    border: " 1px solid #E0E2E6",
                    cursor: "pointer",
                    //  font-weight: 400;			
                  }}

                  // className="rerouteBtn"
                  onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}
                >
                  Cancel
                </button>
                &nbsp;
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: ' 0px 1px 2px 0px #1018280D',
                    color: 'white',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: " #F6F7F8",
                    marginBottom: '14px',
                    fontWeight: 400,
                    border: " 1px solid #E0E2E6",
                    cursor: "pointer",
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    //  font-weight: 400;			
                  }}
                  onClick={() => onClickSubmit()}
                >
                  Submit
                </button>
              </div>
            )}

            {isLoading && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button style={{
                  padding: '8px 12px 8px 12px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  lineHeight: '24px',
                  fontWeight: 400,
                  boxShadow: ' 0px 1px 2px 0px #1018280D',
                  color: 'white',
                  border: '1px solid  #fff',
                  height: '40px',
                  minWidth: '88px',
                  background: " #F6F7F8",
                  marginBottom: '14px',
                  fontWeight: 400,
                  border: " 1px solid #E0E2E6",
                  background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                  cursor: "not-allowed",
                  //  font-weight: 400;			
                }}
                  disabled>
                  Submitting...
                </button>
              </div>
            )}
          </div>

        </ModalBody>
      </Modal>

    </>
  );
}
